import { memo, useEffect, useState, useContext, useRef } from 'react';
import { useTranslation } from "react-i18next";

import './css/QuizSend.css'
import manSrc from '../../images/moe.png'

import { Config } from '../../inc/Config'
import { AppContext } from "../../Context";
import Popups from "../../components/Popups";

import Fetch, { Loader, dateToText } from "../../inc/Fetch";
import { Input, MultiSelect } from "../../components/Form";

import { MdDeleteOutline } from "react-icons/md";

import { Question } from "../../components/Elements";

export default memo(function AddNotes({setopen, open, setAddNotesAllow, setNotesList}) {
    
    const { t } = useTranslation();

    let myStatus = [
        {
            name: "فعال",
            val:1,
        },
        {
            name: "محظور",
            val:0,
        }
    ]
    
    
    const active = useRef(true);
    const {success, userinfo} = useContext(AppContext);
    const [suc, setsuc] = success;
    const [logedIn, setlogedIn] = userinfo;
    
    const [miniTabs, setminiTabs] = useState(open?.tab || 0);

    const [values, setvalues] = useState(open || {});
    const [stats, setstats] = useState({});
    const [avg, setavg] = useState({});
    const [loader, setloader] = useState(false);

    const [ploader, setploader] = useState(true);

    const [myClasses, setmyClasses] = useState([]);



    function deleteNote() {
        let conf = window.confirm("هل أنت متأكد من حذف هذه الملاحظة؟");
        if (!conf) return;

        if (values?._id) {
            setloader(true);
            Fetch("books/deleteNotes", (d) => {
                
                setloader(false);
            }, { _id: values?._id });

            setAddNotesAllow(false);
            setopen(false);
            setNotesList(prev => prev?.length ? prev.filter(v => v?._id != values?._id) : []);
        }
    }

    function submit(e) {
        e.preventDefault();
        setloader(true);

        Fetch("books/addNotes", (d) => {
            
            if (d?.error) {
                setsuc({
                    short:d?.error,
                    error:true
                });
            } else {

                setsuc({
                    title:"Wow!",
                    short:"تم تعديل المعلومات بنجاح.",
                    error:false,
                });

                if (values?._id) {
                    setNotesList(prev => {
                        let arr = [...prev];
                        let index = arr?.findIndex(v => v?._id == values?._id);
                        if (index > -1) {
                            arr[index] = values;
                        }
                        return arr;
                    });
                } else {
                    setNotesList(prev => prev?.length ? [...prev, d] : [d]);
                }

                setTimeout(() => {
                    setAddNotesAllow(false);
                    setopen(false);
                }, 2500);


            }

            setloader(false);
        }, values);

    }


    useEffect(() => {
       if (open?.note) {

       }
    }, [])
    

    return (

        <>
        
        <Popups setOpen={setopen} style={{maxWidth:600, borderTop:"4px solid #fd745a", maxHeight:"96vh"}}>
            {loader && <Loader />}
           <>

                <div className='popupBody interface data quizSend' >

                    <h2 style={{fontSize:24, borderBottom:"1px solid #ddd", background:"#f9f9f9", padding:'15px 20px',}}>الملاحظات</h2>

                    <form onSubmit={submit}>
                        

                        <div className={`tabsSection active`}>

                            <Input
                                title="نص الملاحظة" 
                                name="taskname"
                                type="textarea"
                                validate={true}
                                onChange={(v) => setvalues(p => ({
                                    ...p,
                                    note:v,
                                }))}
                                style={{minWidth:"100%"}}
                                inputStyle={{height:100}}
                                value={values?.note}
                            />

                 
                            <div style={{display:"flex", gap:10}}>
                                <button style={{background:"#33ce79"}} className='btn btnQuizSend'>حفظ المعلومات</button>
                                {open?._id && <button onClick={deleteNote} type='button' style={{background:"#ff4b28"}} className='btn btnQuizSend'>حذف</button>}
                            </div>
                            
                        </div>

                    </form>
                    

                    
                </div>
            </> 

            

        </Popups>
        </>
    );
})